import { AuthContext } from 'auth/context/AuthContext';
import { useContext,useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import { Button,Card,Form,Container,Row, Col } from "react-bootstrap";
import { MensajeAlerta} from '../components/Messages/MensajeAlerta';
import logo from "assets/img/logothvertical.png"


export const Login = () => {
    let valoresLogin={
        Usuario:'',
        Contrasena:''
    }
    const [imageLogo, setImage] = React.useState(logo);
    const navigate = useNavigate();
    const {login,logged}=useContext(AuthContext)
    const [valorLogin, setValoresLogin] = useState(valoresLogin);
    let mensajesAlerta={
        mensaje:'',
        estado:0
    }
    const [mensajeAlerta, setMensaje] = useState(mensajesAlerta);
    

    
    const onLogin = async(event) => {
        
        event.preventDefault();
        const resp=await login(valorLogin);
        if(resp.success){
            
            navigate('/admin', {
                replace: true
                });
        }
        else
        {
            setMensaje({mensaje:resp.message,estado:resp.success})
        }
    }
    
    const onCambio=(event)=>{
        setValoresLogin({ ...valorLogin, [event.target.name]: event.target.value });
    }
    const onRecover = () => {
        navigate('/recuperar', {
            replace: true
        });
    }

    return (
        <>
          <div className="wrapper" style={{ backgroundColor: "#444444" }}>
            <Container fluid>
              {/* Full height y centrado perfecto */}
              <Row className="min-vh-100 py-5 d-flex align-items-center justify-content-center">
                {/* Columna responsiva para el card */}
                <Col xs={12} sm={10} md={6} lg={4}>
                  <Card className="shadow-sm">
                    <Card.Header className="bg-white">
                      <div className="d-flex flex-column align-items-center">
                        <a href="#" className="simple-text logo-mini mx-1">
                          <img
                            src={imageLogo}
                            alt="Logo"
                            style={{ maxWidth: "220px", width: "100%", height: "auto" }}
                          />
                        </a>
                        {/* Si quieres un link bajo el logo, déjalo aquí */}
                        {/* <a className="simple-text mt-2" href="https://url.cl/">Tu enlace</a> */}
                      </div>
                    </Card.Header>
      
                    <Card.Body className="p-3 p-md-4">
                      <Form onSubmit={(e) => e.preventDefault()}>
                        <Row className="g-3">
                          <Col xs={12}>
                            <Form.Group controlId="loginUsuario">
                              <Form.Label>Usuario</Form.Label>
                              <Form.Control
                                name="Usuario"
                                type="text"
                                placeholder=""
                                defaultValue={valoresLogin?.Usuario}
                                onChange={onCambio}
                                autoComplete="username"
                                inputMode="text"
                              />
                            </Form.Group>
                          </Col>
      
                          <Col xs={12}>
                            <Form.Group controlId="loginContrasena">
                              <Form.Label>Contraseña</Form.Label>
                              <Form.Control
                                name="Contrasena"
                                type="password"
                                placeholder=""
                                defaultValue={valoresLogin?.Contrasena}
                                onChange={onCambio}
                                autoComplete="current-password"
                              />
                            </Form.Group>
                          </Col>
      
                          <Col xs={12}>
                            {/* Botonera: apilada en móvil; a la derecha en md+ */}
                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                              <Button
                                type="button"
                                variant="outline-light"
                                className="btn btn-primary"
                                onClick={onRecover}
                              >
                                Recuperar
                              </Button>
                              <Button
                                type="button"
                                variant="primary"
                                className="btn btn-primary"
                                onClick={onLogin}
                              >
                                Ingresar
                              </Button>
                            </div>
                          </Col>
      
                          <Col xs={12}>
                            <MensajeAlerta
                              mensajeTexto={mensajeAlerta.mensaje}
                              estado={mensajeAlerta.estado}
                            />
                          </Col>
                        </Row>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      );
      
}
export default Login;
